import React from "react";

const CustomToast = ({ type, message }) => {
  return (
    <div className={`toastmain ${type}toast`}>
      <div className="toastimg">
        {type === "info" && (
          <>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M11.3855 4.30771C11.3855 4.00343 11.2953 3.70598 11.1262 3.45298C10.9572 3.19999 10.7169 3.0028 10.4358 2.88636C10.1547 2.76991 9.84535 2.73945 9.54692 2.79881C9.24848 2.85817 8.97436 3.00469 8.7592 3.21985C8.54404 3.43501 8.39752 3.70914 8.33816 4.00757C8.27879 4.306 8.30926 4.61534 8.4257 4.89645C8.54215 5.17757 8.73933 5.41784 8.99233 5.58689C9.24533 5.75594 9.54278 5.84617 9.84706 5.84617C10.2551 5.84617 10.6464 5.68408 10.9349 5.39557C11.2234 5.10705 11.3855 4.71573 11.3855 4.30771ZM9.84706 7.38463C10.0919 7.38463 10.3267 7.48188 10.4998 7.655C10.6729 7.82811 10.7701 8.06289 10.7701 8.30771V16C10.7701 16.2448 10.6729 16.4796 10.4998 16.6527C10.3267 16.8258 10.0919 16.9231 9.84706 16.9231C9.60224 16.9231 9.36745 16.8258 9.19434 16.6527C9.02123 16.4796 8.92398 16.2448 8.92398 16V8.30771C8.92398 8.06289 9.02123 7.82811 9.19434 7.655C9.36745 7.48188 9.60224 7.38463 9.84706 7.38463Z" fill="#042733"/>
</svg>
          </>
        )}
        {type === "success" && (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M18.039 6.59139L8.19286 16.4375C8.1071 16.5236 8.0052 16.5919 7.893 16.6385C7.7808 16.6851 7.6605 16.709 7.53901 16.709C7.41752 16.709 7.29723 16.6851 7.18503 16.6385C7.07282 16.5919 6.97092 16.5236 6.88517 16.4375L2.57747 12.1299C2.49161 12.044 2.4235 11.9421 2.37703 11.8299C2.33056 11.7177 2.30664 11.5974 2.30664 11.476C2.30664 11.3546 2.33056 11.2343 2.37703 11.1221C2.4235 11.01 2.49161 10.908 2.57747 10.8222C2.66334 10.7363 2.76527 10.6682 2.87746 10.6217C2.98965 10.5752 3.10989 10.5513 3.23132 10.5513C3.35275 10.5513 3.47299 10.5752 3.58518 10.6217C3.69737 10.6682 3.7993 10.7363 3.88517 10.8222L7.53978 14.4768L16.7329 5.28524C16.9063 5.11183 17.1415 5.0144 17.3867 5.0144C17.6319 5.0144 17.8671 5.11183 18.0406 5.28524C18.214 5.45865 18.3114 5.69384 18.3114 5.93908C18.3114 6.18432 18.214 6.41952 18.0406 6.59293L18.039 6.59139Z"
                fill="var(--toastsvg)"
              />
            </svg>
          </>
        )}
        {type === "error" && (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M16.1926 15.1316C16.366 15.305 16.4634 15.5402 16.4634 15.7854C16.4634 16.0306 16.366 16.2658 16.1926 16.4393C16.0191 16.6127 15.784 16.7101 15.5387 16.7101C15.2935 16.7101 15.0583 16.6127 14.8849 16.4393L10.001 11.5539L5.11563 16.4377C4.94222 16.6111 4.70703 16.7085 4.46179 16.7085C4.21655 16.7085 3.98135 16.6111 3.80794 16.4377C3.63453 16.2643 3.53711 16.0291 3.53711 15.7839C3.53711 15.5386 3.63453 15.3034 3.80794 15.13L8.69333 10.2462L3.80948 5.36079C3.63607 5.18738 3.53865 4.95218 3.53865 4.70694C3.53865 4.4617 3.63607 4.22651 3.80948 4.0531C3.98289 3.87968 4.21809 3.78226 4.46333 3.78226C4.70857 3.78226 4.94376 3.87968 5.11717 4.0531L10.001 8.93848L14.8864 4.05233C15.0598 3.87892 15.295 3.78149 15.5402 3.78149C15.7855 3.78149 16.0207 3.87892 16.1941 4.05233C16.3675 4.22574 16.4649 4.46093 16.4649 4.70617C16.4649 4.95141 16.3675 5.18661 16.1941 5.36002L11.3087 10.2462L16.1926 15.1316Z"
                fill="var(--toastsvg)"
              />
            </svg>
          </>
        )}
        {type === "warning" && (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M11.5398 15.7846C11.5398 16.0889 11.4496 16.3863 11.2805 16.6393C11.1115 16.8923 10.8712 17.0895 10.5901 17.2059C10.309 17.3224 9.99965 17.3528 9.70121 17.2935C9.40278 17.2341 9.12865 17.0876 8.9135 16.8724C8.69834 16.6573 8.55181 16.3831 8.49245 16.0847C8.43309 15.7863 8.46356 15.4769 8.58 15.1958C8.69644 14.9147 8.89363 14.6744 9.14663 14.5054C9.39963 14.3363 9.69707 14.2461 10.0014 14.2461C10.4094 14.2461 10.8007 14.4082 11.0892 14.6967C11.3777 14.9852 11.5398 15.3766 11.5398 15.7846ZM10.0014 12.7077C10.2462 12.7077 10.481 12.6104 10.6541 12.4373C10.8272 12.2642 10.9244 12.0294 10.9244 11.7846V4.09227C10.9244 3.84745 10.8272 3.61266 10.6541 3.43955C10.481 3.26644 10.2462 3.16919 10.0014 3.16919C9.75654 3.16919 9.52175 3.26644 9.34864 3.43955C9.17553 3.61266 9.07828 3.84745 9.07828 4.09227V11.7846C9.07828 12.0294 9.17553 12.2642 9.34864 12.4373C9.52175 12.6104 9.75654 12.7077 10.0014 12.7077Z"
                fill="var(--toastsvg)"
              />
            </svg>
          </>
        )}
      </div>
      <div className="toasttexts">
        <h6 className="toasthead">
          {type.charAt(0).toUpperCase() + type.slice(1)}
        </h6>
        <p className="toastpara">{message}</p>
      </div>
    </div>
  );
};

export default CustomToast;
